WiseMetering.Model.IntegrationConfiguration = WiseMetering.Model.extend({
    urlRoot: '/integration_configurations',

    disable: function(comment, opts) {
        const options = {
            contentType: 'application/json',
            data: JSON.stringify({ comment }),
            type: 'PUT',
            url: `${this.url()}/disable`
        };

        _.extend(options, opts);

        return (this.sync || Backbone.sync).call(this, null, this, options);
    },

    enable: function(opts) {
        const options = {
            contentType: 'application/json',
            type: 'PUT',
            url: `${this.url()}/enable`
        };

        _.extend(options, opts);

        return (this.sync || Backbone.sync).call(this, null, this, options);
    },

    site: function() {
        return WiseMetering.zones.get(this.get('site_id'));
    },

    license: function() {
        return WiseMetering.integrationLicenses.get(this.get('license_id'));
    }
});
